import { Asset } from 'components/common/types/Asset.types';
import { DirectSalesAsset } from 'components/common/types/DirectSalesCampaign.types';

type GroupedAssets = { assets: DirectSalesAsset[]; unavailableAssets: DirectSalesAsset[] };

export const groupDirectSalesAssets = (assets: Asset[] = []): GroupedAssets => {
  return assets.reduce(
    (acc: GroupedAssets, curr) => {
      if (curr.availability === 'Available') acc.assets.push(curr);
      else acc.unavailableAssets.push(curr);

      return acc;
    },
    {
      assets: [],
      unavailableAssets: [],
    },
  );
};
